<div class="container" *ngIf="scoreType">
  <div class="logo">
      <img src="assets/img/ok-face.svg" alt="logo">
  </div>
  <div class="info-content">
      <h3 class="title">{{ scoreType+'_TITLE' | translation }}</h3>
      <p class="description">{{ scoreType+'_DESCRIPTION' | translation }}</p>
  </div>
</div>